import api from './api';

const userService = {
  // login: (payload) => api.post(`/${API_VERSION}/login`, payload),
  login: (payload) => api.post(`/login`, payload),
  
  getUsers: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/admin/user/${queryString ? '?' + queryString : ''}`);
  },
  
  getUserDetails: (userId) => api.get(`/admin/user/${userId}`),
  
  editUser: (userId, payload) => api.put(`/admin/user/${userId}`, payload),
  
  addAdmin: (payload) => api.post(`/admin/add-admin`, payload),
  
  getUserByDateRange: (payload) => {
    const { startDate, endDate, filter = '' } = payload;
    return api.post(
      `/admin/users-by-date-range?startDate=${startDate}&endDate=${endDate}&filter=${filter}`,
      payload
    );
  },
  
  getUserByCreatedDate: (payload) => {
    const { startDate, endDate, filter = '', perPage, currentPage } = payload;
    return api.post(
      `/admin/users-by-created-date?startDate=${startDate}&endDate=${endDate}&filter=${filter}&perPage=${perPage}&currentPage=${currentPage}`,
      payload
    );
  },
  
  getUserSubCreatedDate: (payload) => {
    const { startDate, endDate, filter = '' } = payload;
    return api.post(
      `/admin/users-sub-created-date?startDate=${startDate}&endDate=${endDate}&filter=${filter}`,
      payload
    );
  },
  
  getUserTransactions: (params) => api.get('/admin/user-transactions', { params }),
  
  verifyTransaction: (payload) => api.post('/admin/user-transactions/verify', payload),
  
  getTransactionInvoice: (transactionId) => api.post(`/admin/user-transactions/invoice/${transactionId}`),
  
  setRefundRequested: (payload) => api.post('/admin/user-transactions/request-refund', payload),
};

export default userService;